(function() {
    'use strict';
    
    angular.module('app').controller('ReportingController', ReportingController);

    ReportingController.$inject = [
        'toastr', 
        '$routeParams', 
        '$route', 
        'ReportingDifotTableService', 
        'ReportingCompanyBySpendTableService', 
        'ReportingCarrierBySpendTableService', 
        'Carrier', 
        'Shipments', 
        '$q', 
        '$location' 
    ];

    function ReportingController(
        toastr, 
        $routeParams, 
        $route, 
        ReportingDifotTableService, 
        ReportingCompanyBySpendTableService, 
        ReportingCarrierBySpendTableService, 
        Carrier, 
        Shipments, 
        $q, 
        $location
    ){
        let vm = this;
        const tabs = ['difot-summary', 'company-by-spend', 'carrier-by-spend'];
        let serviceDetailsList = {};
        let chartFilter = angular.fromJson(localStorage.getItem('difotChartFilter')) !== null ? angular.fromJson(localStorage.getItem('difotChartFilter')) : {};
        localStorage.removeItem('difotChartFilter')

        vm.carriers = [];
        vm.changeTab = changeTab;

        Carrier.getCarriers((data)=>{
            serviceDetailsList.carriers = data;
        }, (error)=>{
            toastr.error(error);
        }).getServices((data)=>{
            serviceDetailsList.services = data;
            vm.difotTableData = new ReportingDifotTableService(serviceDetailsList, chartFilter).tableData;
        });

        vm.accountTableData = ReportingCompanyBySpendTableService;
        vm.carrierTableData = ReportingCarrierBySpendTableService;

        function changeTab(index) {
            vm.activeIndex = index;
            return $location.search({tab: tabs[index]});
        }

        (function () {
            if ($routeParams != null) {
                let params = $routeParams;
                let index = vm.activeIndex = tabs.findIndex(tab => params.tab === tab);
                vm.activeIndex = index > -1 ? index : 0;
            }
            if(!$routeParams.tab)
                changeTab(0).replace();
        })();
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/ReportingController.js